import { Component, OnInit } from '@angular/core';
import { IonContent, PopoverController } from '@ionic/angular';

import { Multitenant } from '../../services/multitenant.provider';
import { AuthProvider } from '../../services/auth.provider';
import { StorageProvider } from '../../services/storage.provider';
import { ConfigService } from '../../services/config.service';
import { ArticlesService } from '../../services/articles.service';

import { InfoPopupComponent } from '../../shared/components/infopopup/infopopup';
import { MetaProvider } from '../../services/meta.provider';
import { GaEventTrackerProvider } from '../../services/gaeventtracker.provider';
import { PopUp } from '../../models/popup.model';
import { PopUpService } from '../../shared/components/pop-up/pop-up.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu',
  templateUrl: 'menu.html',
  styleUrls: ['menu.scss']
})
export class MenuPage implements OnInit {

  public isOpen = false;
  public isOpen2 = false;
  public themeClass: string;
  public thematicFilesPage: string;
  public isAuthenticated: boolean;
  public newspapersAccess: any;
  public newspapersNoAccess: any;
  public noAccessLength: any;
  public accessLength: boolean;
  public general = false;
  public thematicfilessubcatPage: string;
  public isActivePage: string;
  public platformType: number;
  public tempPopUp: boolean;
  public noEdit: boolean;
  public popup: PopUp = new PopUp();
  public ua: string;
  public sabSession: boolean;
  public content: IonContent;
  public sab: boolean;
  public slugs: {
    ouiSommesNous: string;
    commentCaMarche: string;
    mentionsLegales: string;
    viePrivee: string;
    cookies: string;
  };
  public theme: any;

  constructor(
    public auth: AuthProvider,
    private router: Router,
    private multiTenant: Multitenant,
    private config: ConfigService,
    private service: ArticlesService,
    private popoverCtrl: PopoverController,
    private storage: StorageProvider,
    private meta: MetaProvider,
    private ga: GaEventTrackerProvider,
    private popUpService: PopUpService
  ) {}

  get hasCkidAccess() {
    const access = this.auth.hasAccessTo();
    return  access.includes('ckid') ? true : false;
  }

  ngOnInit(): void {
    this.themeClass = this.multiTenant.getDomainClass();
    this.getPlatformType();
    if (
      this.themeClass === 'mwjp' ||
      this.themeClass === 'mljp' ||
      this.themeClass === 'mwde' ||
      this.themeClass === 'mlde' ||
      this.themeClass === 'clfy'
    ) {
      this.slugs = this.staticSlugs(this.themeClass);
    } else {
      this.slugs = this.staticSlugs('playbacpresse');
    }
    if (this.storage.getStorage('cas')) {
      this.noEdit = true;
    } else {
      this.noEdit = false;
    }
    this.ua = this.getUserUa();
    this.sabSession = sessionStorage.getItem('sab') === 'closed' ? true : false;
  }

  ionViewDidEnter() {
    this.isActivePage = 'menu';
    this.isAuthenticated = this.auth.isAuthenticated();
    this.newspapersNoAccess = this.auth.getNoAccessNewspaapers();
    const len = this.auth.getNoAccessNewspaapers().length;
    if (len === 0) {
      this.noAccessLength = false;
    } else {
      this.noAccessLength = true;
    }
    this.newspapersAccess = this.auth.getAccessNewspapers();
    const authlen = this.auth.getAccessNewspapers().length;
    if (authlen === 0) {
      this.accessLength = false;
    } else {
      this.accessLength = true;
    }
    if (this.isAuthenticated) {
      const newspaper = this.auth.hasAccessToMain();
      if (newspaper) {
        const newspaperarray = this.auth.hasAccessToMain().split(',');
        if (newspaperarray.length === 1) {
          this.service.getThematicFilesCategories(newspaper).subscribe((response) => {
            if (response[0].name === 'Général') {
              this.general = true;
              this.theme = response[0];
              this.thematicfilessubcatPage = 'ThematicfilessubcatPage';
            }
          });
        }
      }
    }
    this.meta.clearHead();

    if (
      !this.auth.isAuthenticated() &&
      this.popUpService.havePassedSevenDays() &&
      this.multiTenant.getDomainClass() === 'playbacpresse'
    ) {
      this.tempPopUp = true;
      this.popup.type = 'unIdentifiedUser';
    }
  }

  ionViewCanEnter() {
    if (this.auth.logedWithNoProfiles()) {
      this.router.navigate(['creer-compte', 'etape-2']);
    } else if (this.auth.isPartiallyAuthenticated()) {
      this.router.navigate(['profiles']);
    } else {
      return true;
    }
  }
  getPlatformType() {
    const platform = this.multiTenant.getDomainClass();

    if (
      platform === 'mquo' ||
      platform === 'actu' ||
      platform === 'aeco' ||
      platform === 'lepq' ||
      platform === 'playbacpresse'
    ) {
      this.platformType = 0;
    } else if (
      platform === 'week' ||
      platform === 'mlwk' ||
      platform === 'mwne' ||
      platform === 'mlne' ||
      platform === 'sema' ||
      platform === 'woch'
    ) {
      this.platformType = 1;
    } else if (platform === 'mquovideo' || platform === 'actuvideo') {
      this.platformType = 2;
    } else if (platform === 'clfy') {
      this.platformType = 4;
    } else {
      this.platformType = 3;
    }
  }

  setThematicFilesPage() {
    if (this.auth.isAuthenticated() && this.auth.oneMainNewspaper()) {
      return 'ThematicfilescatPage';
    } else {
      return 'ThematicfilesPage';
    }
  }

  goToThematicFiles(page) {
    if (page === 'ThematicfilesPage') {
      this.router.navigate(['dossiers-actualite']);
    }

    if (page === 'ThematicfilescatPage' || page === 'ThematicfilessubcatPage') {
      this.router.navigate(['dossiers-actualite', this.themeClass, this.theme.slug]);
    }
  }

  public goToJOThematicFiles() {
    switch (this.auth.hasAccessToMain()) {
      case 'lepq':
        this.router.navigate(['/dossiers-actualite', this.auth.hasAccessToMain(), 'general', 'les-jeux-olympiques-et-paralympiques-de-paris-2024']);
        break;
      case 'mquo':
        this.router.navigate(['/dossiers-actualite', this.auth.hasAccessToMain(), 'general', 'les-jeux-olympiques-et-paralympiques-de-paris-2024-1']);
        break;
      case 'actu':
        this.router.navigate(['/dossiers-actualite', this.auth.hasAccessToMain(), 'general', 'les-jeux-olympiques-et-paralympiques-de-paris-2024-2']);
        break;
    }
  }

  goToFavoris() {
    if (this.auth.isAuthenticated()) {
      this.router.navigate(['favoris']);
    } else {
      this.router.navigate(['connexion']);
    }
  }

  openExternal(url) {
    if (this.auth.isAuthenticated()) {
      this.tempPopUp = true;
      this.popup.type = 'menuPlatformLinks';
      this.popup.data = url;
    } else {
      window.open(url, '_blank');
    }
  }

  filterArticles(newspaper) {
    this.router.navigate([''], { queryParams: { filter: newspaper } });
  }

  filterCategory(newspaper: string, category: string) {
    if (this.auth.isAuthenticated()) {
      this.router.navigate([''], { queryParams: { filter: newspaper, category }});
    } else {
      this.router.navigate(['connexion']);
    }
  }

  filterCategoryAuth(category: string) {
    this.router.navigate([''], { queryParams: { filter: this.themeClass, category }});
  }

  goToBookOfMonth() {
    this.router.navigate(['actu-livres']);
  }

  async presentPopover(myEvent) {
    const popover = this.popoverCtrl.create({component: InfoPopupComponent, cssClass: 'feature-tooltip', componentProps: { page: 'home' }});
    (await popover).present(myEvent);
  }

  goToEdit() {
    if (!this.auth.isAuthenticated()) {
      this.router.navigate(['connexion']);
    } else {
      this.router.navigate(['profiles']);
    }
  }

  goToExternal(url) {
    if ( this.themeClass === 'mquovideo' && url === 'https://www.playbacpresse.fr/boutique.3.les-abonnements.php' ) {
      window.open('https://www.playbacpresse.fr/abonnements-mon-quotidien-video', '_blank' );
    } else if ( this.themeClass === 'actuvideo' && url === 'https://www.playbacpresse.fr/boutique.3.les-abonnements.php' ) {
      window.open('https://www.playbacpresse.fr/abonnements-l-actu-video', '_blank');
    } else if (this.themeClass === 'week') {
      window.open( 'https://www.playbacpresse.fr/abonnements-my-weekly', '_blank' );
    } else if (this.themeClass === 'mwne') {
      window.open( 'https://www.playbacpresse.fr/abonnements-my-weekly-news', '_blank' );
    } else if (this.themeClass === 'sema') {
      window.open('https://www.playbacpresse.fr/abonnements-mi-semanal', '_blank' );
    } else if (this.themeClass === 'woch') {
      window.open('https://www.playbacpresse.fr/abonnements-meine-woche', '_blank');
    } else if (this.themeClass === 'mlwk') {
      window.open('https://www.playbacpresse.fr/abonnements-my-little-weekly', '_blank');
    } else if (this.themeClass === 'mlne') {
      window.open('https://www.playbacpresse.fr/abonnements-my-little-weekly-news', '_blank');
    } else if (this.themeClass === 'lepq') {
      window.open('https://www.playbacpresse.fr/abonnements-le-petit-quotidien', '_blank');
    } else if (this.themeClass === 'mquo') {
      window.open('https://www.playbacpresse.fr/abonnements-mon-quotidien', '_blank');
    } else if (this.themeClass === 'actu') {
      window.open('https://www.playbacpresse.fr/abonnements-l-actu', '_blank');
    } else if (this.themeClass === 'aeco') {
      window.open('https://www.playbacpresse.fr/abonnements-l-eco', '_blank');
    } else if (this.themeClass === 'mwjp') {
      window.open('https://www.playbacpresse.fr/my-little-weekly-my-weekly-japonais', '_blank');
    } else if (this.themeClass === 'mwde') {
      window.open('https://go.playbacpresse.fr/myweekly-german_2019.html', '_blank');
    } else if (this.themeClass === 'mljp') {
      window.open('https://www.playbacpresse.fr/my-little-weekly-my-weekly-japonais', '_blank');
    } else if (this.themeClass === 'mlde') {
      window.open('https://go.playbacpresse.fr/mylittleweekly-german_2019.html', '_blank');
    } else {
      window.open(url, '_blank');
    }
  }

  goToExternalClub(url: string) {
    window.open(url, '_blank');
  }

  goToExternalFAQ(url: string) {
    window.open(url, '_blank');
  }

  badContent() {
    window.location.href = 'mailto:support@playbac.fr';
  }

  goStaticPage(slug) {
    this.router.navigate(['page', slug]);
  }

  onNotifyPopUp(message: string): void {
    this.tempPopUp = false;
  }
  onBottomMenuNotify(message: string): void {
    this.tempPopUp = true;
    this.popup.type = 'featureToCome';
  }

  goToConcours() {
    this.router.navigate(['about']);
  }

  showTempPopUp() {
    if ( this.themeClass !== 'playbacpresse' && !this.storage.getStorage('hybridApp') ) {
      this.tempPopUp = true;
      this.popup.type = 'hybridApp';
      this.popup.platform = this.themeClass;
    }
  }

  getUserUa() {
    const ua = window.navigator.userAgent;
    const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    const webkit = !!ua.match(/WebKit/i);
    const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
    const isAndroid = !iOSSafari && navigator.userAgent.match(/android/i) != null;

    return isAndroid ? 'android' : 'ios';
  }

  hideSAB() {
    this.sab = true;
  }

  staticSlugs(subName: string): {
    ouiSommesNous: string;
    commentCaMarche: string;
    mentionsLegales: string;
    viePrivee: string;
    cookies: string;
  } {
    return this.config.getStaticSlugs(subName);
  }

  isChildProfile(): boolean {
    if (this.auth.getProfileType !== 'Children') {
      return false;
    } else {
      return true;
    }
  }

  goToExternalArchives() {
    this.ga.trackEvent( this.multiTenant.getNewspaperName(), 'clic', 'Archives', null);
    if (this.storage.getStorage('logged_profile_id')) {
      const profileId = this.storage.getStorage('logged_profile_id');
      window.open( 'http://archives.playbacpresse.fr/?token=78372' + profileId + '93287', '_blank' );
    } else {
      this.router.navigate(['connexion']);
    }
  }

  public isTeacherProfile(): any {
    return this.storage.getStorage('logged_profile_type') && this.storage.getStorage('logged_profile_type') === 'Teacher';
  }
}
